/**
 * **************************************************************************
 * Workflow Execution History - service file
 * 
 * Defines all http api calls required in workflow execution history component
 * Calls server apis and returns data to components
 * **************************************************************************
 */

import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@app/services/api.service';
import { Observable } from 'rxjs';
import { IWorkflowHistoryResponse } from '@app/interfaces/IWorkflowExecutionHistory';

@Injectable({
  providedIn: 'root'
})
export class WorkflowExecutionHistoryService {

  /****************** Variable declaration ******************/
  /* Defined urls */
  private wfJobUrl = this.apiService.KPID_URL + this.apiService.WF_JOB_APIS.WF_JOB;

  /**
   * Constructor
   * @param httpClient 
   * @param apiService 
   */
  constructor(
    private httpClient: HttpClient,
    private apiService: ApiService
  ) { }

  /**
   * Retrieve the workflow execution history for a given PR URL or commit id
   * @param prUrl - Pull Request URL (query parameter; used when available)
   * @param commitId - Commit id (query parameter; used when no PR URL is available, e.g. push events)
   * @param page - Page number (optional, query parameter)
   * @param perPage - Items per page (optional, query parameter)
   * @returns Observable with workflow execution history data
   */
  getWorkflowExecutionHistory(prUrl: string, commitId?: string, page?: number, perPage?: number): Observable<IWorkflowHistoryResponse> {
    // Build query parameters (prUrl or commitId identifies the execution; page/perPage are pagination)
    let params = new HttpParams();

    // Identify the execution by PR URL when available, otherwise by commit id (push events)
    if (prUrl) {
      params = params.set('prUrl', prUrl);
    } else if (commitId) {
      params = params.set('commitId', commitId);
    }

    // Add optional pagination parameters if provided
    if (page !== undefined && page !== null) {
      params = params.set('page', page.toString());
    }
    if (perPage !== undefined && perPage !== null) {
      params = params.set('perPage', perPage.toString());
    }
    
    // Construct URL without prUrl in the path
    const url = this.wfJobUrl + this.apiService.WF_JOB_APIS.JOB_HISTORY_TABLE;
    return this.httpClient.get<IWorkflowHistoryResponse>(url, { params });
  }
}
